<template>
<div class="container">
    <el-button @click="clearAll">清空</el-button>
<el-upload
    class="avatar-uploader"
    :action="domain"
    list-type="picture-card"
    :on-success="UploadFaceImg"
    :data="QiNiYunL"
    :before-upload="gettoken"
    :file-list="fileList"
    :on-remove="handleRemove"
    ref="imgsUploader"
    :limit="9"
    :on-exceed="exceed"
  >
    <i slot="default" class="el-icon-plus avatar-uploader-icon"></i>
    <div slot="fileList" slot-scope="{ file }">
      <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
      <span class="el-upload-list__item-actions">
        <span
          v-if="!disabled"
          class="el-upload-list__item-delete"
          @click="handleRemove()"
        >
          <i class="el-icon-delete avatar-uploader-icon"></i>
        </span>
      </span>
    </div>
  </el-upload>

  <div>
    最新上传的图片链接
  </div>
  <p>
    {{img}}
    <el-button type="text" @click="copyText">复制</el-button>
  </p>
</div>
</template>

<script>
import {getPicKeyName} from "@/utils/utils.js"
export default {
  props:{
    limit:{
      type:Number,
      default:9
    },
    clear:{
      type:Boolean,
      default:false
    },
    urls:{
      type:String,
    }
  },
  data() {
    return {
      imgList: [],
      fileList: [],
      domain: "http://up-z0.qiniup.com/",
      upload_qiniu_addr: "https://img.curiousmore.com/",
      disabled: false,
      QiNiYunL: {
        key: "",
        token: "",
      },
      img:''
    };
  },
  methods: {
    async copyText(){
        await navigator.clipboard.writeText(this.img);  
        this.$message('复制成功')
    },
    exceed(){
       this.$message("不能上传更多了")
    },
    clearAll(){
       this.$refs.imgsUploader.clearFiles();
    },
    handleRemove(file) {
      let imgIndex;
      if (file.response) {
        imgIndex = this.imgList.findIndex((item, index, arr) => {
          return item == this.upload_qiniu_addr + file.response.key;
        });
      } else {
        imgIndex = this.imgList.findIndex((item, index, arr) => {
          return item == file.url;
        });
      }

      this.imgList.splice(imgIndex, 1);
      this.$emit("getImgUrl", this.imgList.join(","));
    },

    UploadFaceImg(file) {
      this.img = this.upload_qiniu_addr + file.key
    },
    gettoken() {
      let _this = this;
      var timestamp = getPicKeyName()
      let data = {
        key: timestamp,
        type: "pic",
      };

      return new Promise((resolve,reject)=>{
          _this
        .$axios({
          method: "post",
          url: "https://curiousmore.com/qmore/push/upload/getToken",
          data: data,
        })
        .then((res) => {
          _this.QiNiYunL.token = res.data.data;
          _this.QiNiYunL.key = data.key;
          resolve()
        })
        .catch((err) => {
          console.log(err);
          reject()
        });
      })

      
    },
  }
};
</script>

<style>
/* .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 14px;
  color: #8c939d;
  width: 5.6rem;
  height: 5.6rem;
  line-height: 5.6rem;
  text-align: center;
}
.avatar {
  width: 5.6rem;
  height: 5.6rem;
  display: block;
} */
</style>
